var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDocXls = function SvgIcDocXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 33V106.667C113.333 114 107.333 120 99.9993 120H19.9993C12.666 120 6.66602 114 6.66602 106.667V13.3333C6.66602 6 12.666 0 19.9993 0H80.3327L113.333 33Z",
    fill: "#62C558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.334 26.3333V0L113.334 33H87.0007C83.334 33 80.334 30 80.334 26.3333Z",
    fill: "#2A8121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84.8467L74.8467 90L40 55.1567L45.1533 50L80 84.8467ZM53.2133 71.6167L58.38 76.7833L45.1667 90L40 84.8333L53.2133 71.6167ZM80 55.1667L66.75 68.4167L61.5833 63.25L74.8333 50L80 55.1667Z",
    fill: "white"
  })));
};
export default SvgIcDocXls;